export var SubscriptionsTexts;
(function (SubscriptionsTexts) {
    SubscriptionsTexts["BILLING"] = "Billing";
    SubscriptionsTexts["CANCELLED"] = "Your subscription has been canceled";
    SubscriptionsTexts["DELIVER_TO"] = "Deliver to";
    SubscriptionsTexts["DETAILS"] = "Details";
    SubscriptionsTexts["DO_NOT_DISPLAY"] = "DO_NOT_DISPLAY";
    SubscriptionsTexts["EDIT_SUB"] = "Edit";
    SubscriptionsTexts["ENDING_IN"] = "ending in";
    SubscriptionsTexts["ERROR"] = "Error!";
    SubscriptionsTexts["EVERY"] = "Every";
    SubscriptionsTexts["FREQUENCY"] = "Frequency";
    SubscriptionsTexts["LIFESTYLE_CHOICE"] = "Dietary Lifestyle Choice";
    SubscriptionsTexts["LOADING_SUBSCRIPTIONS"] = "Loading subscriptions...";
    SubscriptionsTexts["NO_CREDIT_CARD"] = "No credit card found!";
    SubscriptionsTexts["NO_SUBSCRIPTIONS_TO_DISPLAY"] = "No subscriptions to display.";
    SubscriptionsTexts["PAUSE_PROBLEM"] = "There was a problem pausing your subscription. Please try again later.";
    SubscriptionsTexts["PAUSE_SUB"] = "Pause";
    SubscriptionsTexts["PAUSED"] = "Your subscription has been paused.";
    SubscriptionsTexts["PICKUP_AT"] = "Pickup at";
    SubscriptionsTexts["PLEASE_CONTACT_CHANGES"] = "Please contact us to make changes to your subscription.";
    SubscriptionsTexts["PROBLEM_CANCELLING"] = "There was a problem cancelling your subscription. Please try again later.";
    SubscriptionsTexts["PROBLEM_RESUMING"] = "There was a problem resuming your subscription. Please try again later.";
    SubscriptionsTexts["PROGRAM_NAME"] = "Program Name";
    SubscriptionsTexts["RESUME_SUB"] = "Resume";
    SubscriptionsTexts["SOMETHING_UNEXPECTED_S1"] = "Something unexpected happened while loading the page. Code: S1";
    SubscriptionsTexts["SOMETHING_UNEXPECTED_S2"] = "Something unexpected happened while loading the page. Code: S2";
    SubscriptionsTexts["SUB_NUMBER"] = "Subscription #";
    SubscriptionsTexts["SUB_OPTIONS"] = "Subscription Options";
    SubscriptionsTexts["SUBSCRIPTION_DETAILS"] = "Details";
    SubscriptionsTexts["SUBSCRIPTIONS_TITLE_TEXT"] = "Subscriptions";
    SubscriptionsTexts["SUBTOTAL"] = "Subtotal";
    SubscriptionsTexts["SUCCESS"] = "Success!";
    SubscriptionsTexts["TOTAL"] = "Total";
    SubscriptionsTexts["UNSUBSCRIBE"] = "Unsubscribe";
    SubscriptionsTexts["UPDATE_DELIVERY"] = "Update Delivery";
    SubscriptionsTexts["WEEK"] = "week.";
    SubscriptionsTexts["WEEKS"] = "weeks.";
    SubscriptionsTexts["YOUR_NEXT_ORDER"] = "your next order.";
})(SubscriptionsTexts || (SubscriptionsTexts = {}));
export var AccountSubscriptionsReducerActions;
(function (AccountSubscriptionsReducerActions) {
    AccountSubscriptionsReducerActions["SET_CANCEL_REASONS"] = "SET_CANCEL_REASONS";
    AccountSubscriptionsReducerActions["SET_CUSTOM_TEXT"] = "SET_CUSTOM_TEXT";
    AccountSubscriptionsReducerActions["SET_CUSTOMER_DATA"] = "SET_CUSTOMER_DATA";
    AccountSubscriptionsReducerActions["SET_SUBSCRIPTIONS"] = "SET_SUBSCRIPTIONS";
    AccountSubscriptionsReducerActions["UPDATE_SUBSCRIPTION_STATUS"] = "UPDATE_SUBSCRIPTION_STATUS";
})(AccountSubscriptionsReducerActions || (AccountSubscriptionsReducerActions = {}));
export var SubStatusEnum;
(function (SubStatusEnum) {
    SubStatusEnum["ACTIVE"] = "Active";
    SubStatusEnum["CANCELLED"] = "Cancelled";
    SubStatusEnum["COMPLETE"] = "Complete";
    SubStatusEnum["NONE"] = "None";
    SubStatusEnum["PAUSED"] = "Paused";
})(SubStatusEnum || (SubStatusEnum = {}));
